export const GET_TOKEN = 'get_token'
export const LogOut_Employee = 'logout_employee'

export const Logout = todo => ({
    type: LogOut_Employee,
    payload: {
        ...todo
    }
})

export const GetToken = (tokenObj) => {
    return {
        type: GET_TOKEN,
        payload: { tokenObj }
    }
}